import HeadContext from 'Contexts/HeadContext';
import { useContext, useEffect } from 'react';

const usePageTitle = (title: string) => {
  const { setTitle } = useContext(HeadContext);

  useEffect(() => {
    setTitle(title);
  }, [title, setTitle]);
};

export default usePageTitle;
